import { initializeTradeEnvState } from './tradeEnvFields';

// The 00:00 and 8:30 "open" answers are stored as 'above' / 'below' / null,
// while the entry forms work with true / false / null. Older records may hold booleans.
export const ALIGNMENT_FIELD_IDS = ['aboveBelow0000', 'aboveBelow0830'];

export const isAlignmentField = (fieldId) => ALIGNMENT_FIELD_IDS.includes(fieldId);

export function decodeAlignmentValue(raw) {
  if (raw === 'above' || raw === true || raw === 'true') return true;
  if (raw === 'below' || raw === false || raw === 'false') return false;
  return null;
}

export function encodeAlignmentValue(value) {
  if (value === true) return 'above';
  if (value === false) return 'below';
  return null;
}

/** Form state for the trade-environment fields of an existing entry. */
export function readTradeEnvFromEntry(fields, entryData = {}) {
  const state = initializeTradeEnvState(fields);
  (Array.isArray(fields) ? fields : []).forEach((field) => {
    if (!field?.enabled || !field.id) return;
    const raw = entryData?.[field.id];
    if (raw === undefined) return;
    state[field.id] = isAlignmentField(field.id) ? decodeAlignmentValue(raw) : raw;
  });
  return state;
}

/**
 * Trade-environment values to write for an edited entry. Only enabled fields are
 * written. Untouched fields write back exactly what was stored (or nothing, when the
 * entry never had the field), so a save without changes cannot flip or invent an answer.
 * Changed alignment answers are encoded as 'above' / 'below' / null.
 */
export function buildTradeEnvUpdate(fields, currentState = {}, loadedState = {}, entryData = {}) {
  const update = {};
  (Array.isArray(fields) ? fields : []).forEach((field) => {
    if (!field?.enabled || !field.id) return;
    const { id } = field;
    const current = currentState?.[id];
    if (current === loadedState?.[id]) {
      if (entryData?.[id] !== undefined) update[id] = entryData[id];
      return;
    }
    if (isAlignmentField(id)) {
      update[id] = encodeAlignmentValue(current);
    } else {
      update[id] = current === undefined ? null : current;
    }
  });
  return update;
}

/** Trade-environment values for a brand-new entry (alignment answers always encoded). */
export function buildTradeEnvForNewEntry(state = {}) {
  const values = { ...(state || {}) };
  ALIGNMENT_FIELD_IDS.forEach((id) => {
    values[id] = encodeAlignmentValue(values[id]);
  });
  return values;
}
